import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-white py-6 sm:py-9" data-id="element-180" data-mp="3kqw3yjl330fl">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-181" data-mp="3fze45yusr5w7">
        <h2 className="text-center text-[23px] leading-none text-navy sm:text-[38px]" data-id="element-182" data-mp="3fxuj7uy746o3">
          What technicians say <span className="text-diag" data-id="element-183" data-mp="3ayhxjdj295n3">in the bay</span>
        </h2>

        <div className="mt-4 grid gap-2.5 sm:gap-3 lg:grid-cols-2" data-id="element-184" data-mp="36zr35e5zc23o">
          {testimonials.map((testimonial, i) => <article key={testimonial.name} className={`flex flex-col rounded-md border border-line bg-white p-3.5 sm:p-4 ${i === 0 ? 'border-l-4 border-l-diag lg:col-span-2' : ''}`} data-id="element-185" data-mp="321z9aelry5wu" data-mpi={i}>
              <div className="flex gap-0.5" role="img" aria-label="5 out of 5 stars" data-id="element-186" data-mp="v9omle2pl5zt">
                {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-4 w-4 text-gold" fill="currentColor" strokeWidth={0} aria-hidden="true" data-id="element-187" data-mp="qb54xpv5egd9" />)}
              </div>
              <p className="mt-2 text-[13.5px] font-medium leading-snug text-navy sm:text-[15px]" data-id="element-188" data-mp="79bnfosgsk12">
                “{testimonial.quote}”
              </p>
              <div className="mt-auto flex items-center gap-3 pt-3" data-id="element-189" data-mp="zwpr05qo4du5">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-navy font-display text-[15px] font-bold text-white" aria-hidden="true" data-id="element-190" data-mp="zyivbedt6lyz">
                  {testimonial.name.charAt(0)}
                </span>
                <div data-id="element-191" data-mp="v3mt5leuyi85">
                  <p className="font-display text-[14px] font-bold uppercase leading-none text-navy" data-id="element-192" data-mp="1ivadfkhm6v1g">
                    {testimonial.name}, {testimonial.age}
                  </p>
                  <p className="mt-1 text-[11.5px] font-semibold uppercase tracking-wide text-steel" data-id="element-193" data-mp="1no3dvw61vh7q">
                    {testimonial.role} · {testimonial.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}